'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchBidderDataIfNeeded = exports.setSearchExclusion = exports.logOutBidder = exports.getMainhostLogin = exports.isProfileComplete = exports.isBidderLoaded = exports.getBidderId = exports.getUserData = exports.isUserAtLeastPartiallyRegistered = exports.isUserLoggedIn = exports.isUserPartiallyRegistered = exports.isConfirmPasswordTriggered = exports.getStripeShippingAddress = exports.getProfileAddress = exports.getCreditCard = exports.getIsStripeCustomer = exports.getBidderType = exports.getBidderEmail = exports.getAuthToken = exports.getUserExcludedFacets = exports.upgradeFacetToComplexFacet = exports.annotateFacetExclusions = exports.SET_FACET_EXCLUSION_SUCCESS = exports.SET_FACET_EXCLUSION_REQUEST = exports.SET_FACET_EXCLUSION_FAIL = exports.LOG_OUT_BIDDER = exports.LOAD_BIDDER_DATA_SUCCESS = exports.LOAD_BIDDER_DATA_REQUEST = exports.LOAD_BIDDER_DATA_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _completeAccount = require('../modules/completeAccount');

var _createAccount = require('../modules/createAccount');

var _login = require('../modules/login');

var _passwordReset = require('../modules/passwordReset');

var _updateAccount = require('../modules/updateAccount');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _confirmPassword = require('../modules/confirmPassword');

var _reselect = require('reselect');

var _config = require('../modules/config');

var _jwtDecode = require('jwt-decode');

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _shouldLogin = require('../modules/shouldLogin');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_BIDDER_DATA_FAIL = exports.LOAD_BIDDER_DATA_FAIL = 'la/domain/bidderData/LOAD_FAIL';
var LOAD_BIDDER_DATA_REQUEST = exports.LOAD_BIDDER_DATA_REQUEST = 'la/domain/bidderData/LOAD_REQUEST';
var LOAD_BIDDER_DATA_SUCCESS = exports.LOAD_BIDDER_DATA_SUCCESS = 'la/domain/bidderData/LOAD_SUCCESS';
var LOG_OUT_BIDDER = exports.LOG_OUT_BIDDER = 'LOG_OUT_BIDDER';
var SET_FACET_EXCLUSION_FAIL = exports.SET_FACET_EXCLUSION_FAIL = 'la/domain/bidderData/SET_FACET_EXCLUSION_FAIL';
var SET_FACET_EXCLUSION_REQUEST = exports.SET_FACET_EXCLUSION_REQUEST = 'la/domain/bidderData/SET_FACET_EXCLUSION_REQUEST';
var SET_FACET_EXCLUSION_SUCCESS = exports.SET_FACET_EXCLUSION_SUCCESS = 'la/domain/bidderData/SET_FACET_EXCLUSION_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var UNREGISTERED = 'unregistered';
var PARTIALLYREGISTEREDBIDDER = 'PartiallyRegisteredBidder';
var REGISTEREDBIDDER = 'bidder';

/* reducer */
var DEFAULT_STATE = {
    authName: '',
    authNuid: '',
    authVerify: '',
    confirmPasswordRequiredTriggered: false,
    excludedFacets: {
        auctionHouse: []
    },
    loaded: 0,
    loading: false,
    mobile: '',
    stripeCustomer: {},
    token: '',
    userData: {}
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var time = void 0;

    switch (action.type) {
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends4.default)({}, state, {
                loaded: time,
                loading: false,
                token: action.payload
            });
        case _login.LOGIN_SUCCESS:
        case _confirmPassword.CONFIRM_PASSWORD_SUCCESS:
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
        case _passwordReset.PASSWORD_RESET_SUCCESS:
            time = action.meta.actionTime;
            if (typeof action.payload.annualNMS !== 'undefined') {
                action.payload.bidder.ANMS = action.payload.annualNMS;
            }
            return (0, _extends4.default)({}, state, {
                authName: action.payload.mainhostLogin['5Xq_name'],
                authNuid: action.payload.mainhostLogin['5Xq_nuid'],
                authVerify: action.payload.mainhostLogin['5Xq_nverify'],
                confirmPasswordRequiredTriggered: false,
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload.searchExclusions),
                loaded: time,
                loading: false,
                stripeCustomer: action.payload.stripeCustomer,
                token: action.payload.token,
                userData: (0, _extends4.default)({}, action.payload.bidder, {
                    bidderId: Number(action.payload.bidder.bidderId)
                })
            });
        case LOAD_BIDDER_DATA_REQUEST:
        case _login.LOGIN_REQUEST:
        case _createAccount.CREATE_ACCOUNT_REQUEST:
        case _completeAccount.COMPLETE_ACCOUNT_REQUEST:
        case _passwordReset.PASSWORD_RESET_REQUEST:
        case _updateAccount.UPDATE_ACCOUNT_REQUEST:
        case SET_FACET_EXCLUSION_REQUEST:
            return (0, _extends4.default)({}, state, {
                loading: true
            });
        case LOAD_BIDDER_DATA_SUCCESS:
        case _updateAccount.UPDATE_ACCOUNT_SUCCESS:
            time = action.meta.actionTime;
            if (typeof action.payload.annualNMS !== 'undefined') {
                action.payload.bidder.ANMS = action.payload.annualNMS;
            }
            return (0, _extends4.default)({}, state, {
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload.searchExclusions),
                loaded: time,
                loading: false,
                stripeCustomer: action.payload.stripeCustomer,
                userData: (0, _extends4.default)({}, action.payload.bidder, {
                    bidderId: Number(action.payload.bidder.bidderId)
                })
            });
        case _shouldLogin.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends4.default)({}, state, {
                confirmPasswordRequiredTriggered: true
            });
        case LOG_OUT_BIDDER:
            return DEFAULT_STATE;
        case SET_FACET_EXCLUSION_SUCCESS:
            time = action.meta.actionTime;
            return (0, _extends4.default)({}, state, {
                excludedFacets: renameSearchExclusionsToFacetIds(action.payload),
                loaded: time,
                loading: false
            });
        case SET_FACET_EXCLUSION_FAIL:
            return (0, _extends4.default)({}, state, {
                loading: false
            });
        default:
            return state;
    }
}

// TODO: remove this, and instead update the item api to return correct names

/* HELPERS */
var FACET_ID_LEGEND = {
    houseIds: 'auctionHouse'
};

// Maps facet names returned by the api to facet names used within the application
var renameSearchExclusionsToFacetIds = function renameSearchExclusionsToFacetIds() {
    var searchExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _keys2.default)(searchExclusions).reduce(function (excludedFacets, key) {
        return (0, _extends4.default)({}, excludedFacets, (0, _defineProperty3.default)({}, FACET_ID_LEGEND[key], searchExclusions[key].map(function (option) {
            return option.toString();
        })));
    }, {});
};

// END TODO

var annotateFacetExclusions = exports.annotateFacetExclusions = function annotateFacetExclusions() {
    var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var exclusions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return facets.map(function (facet) {
        return !exclusions[facet.id] ? facet : (0, _extends4.default)({}, facet, {
            excludable: true,
            options: facet.options.map(function (option) {
                return (0, _extends4.default)({}, option, {
                    excluded: exclusions[facet.id].includes(option.id)
                });
            })
        });
    });
};

var upgradeFacetToComplexFacet = exports.upgradeFacetToComplexFacet = function upgradeFacetToComplexFacet(facetOptions, exclusions) {
    return {
        exclusions: exclusions,
        inclusions: facetOptions
    };
};

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.user.user;
};

var userDataSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.userData;
});
var stripeCustomerSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.stripeCustomer;
});

var getUserExcludedFacets = exports.getUserExcludedFacets = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.excludedFacets || (0, _cloneDeep2.default)(DEFAULT_STATE.excludedFacets);
});

var getAuthToken = exports.getAuthToken = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.token ? state.token : null;
});

var getBidderEmail = exports.getBidderEmail = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData.email ? userData.email : '';
});

var getBidderType = exports.getBidderType = (0, _reselect.createSelector)(getAuthToken, function (token) {
    if (token) {
        try {
            // TODO: see if this try catch is enough.  We shouldn't throw if something is wrong
            return (0, _jwtDecode2.default)(token).type;
        } catch (error) {
            return UNREGISTERED;
        }
    }
    return UNREGISTERED;
});

var getIsStripeCustomer = exports.getIsStripeCustomer = (0, _reselect.createSelector)(stripeCustomerSelector, function (stripeCustomer) {
    return !!stripeCustomer.id;
});

var getSmallCardDetails = function getSmallCardDetails(card) {
    return {
        brand: card.brand,
        last4: card.last4,
        month: card.exp_month,
        name: card.name,
        token: card.id,
        year: card.exp_year
    };
};

var getCreditCard = exports.getCreditCard = (0, _reselect.createSelector)([stripeCustomerSelector, getIsStripeCustomer], function (stripeCustomer, isStripeCustomer) {
    if (!isStripeCustomer) {
        return {};
    }
    var default_source = stripeCustomer.default_source,
        sources = stripeCustomer.sources;
    var data = sources.data;


    if (sources.total_count === 1) {
        return getSmallCardDetails(data[0]);
    }

    var card = data.find(function (x) {
        return x.id === default_source;
    }) || {};
    return getSmallCardDetails(card);
});

var defaultAddress = {
    address: '',
    address2: '',
    city: '',
    country: '',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    state: '',
    zip: ''
};

var getProfileAddress = exports.getProfileAddress = (0, _reselect.createSelector)([userDataSelector], function (userData) {
    return {
        address: userData.address || '',
        address2: userData.address2 || '',
        city: userData.city || '',
        country: userData.country || '',
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        mobileNumber: userData.mobileNumber || userData.phoneNumber || '',
        state: userData.state || '',
        zip: userData.zip || ''
    };
});

var getStripeShippingAddress = exports.getStripeShippingAddress = (0, _reselect.createSelector)([stripeCustomerSelector, getIsStripeCustomer, userDataSelector], function (stripeCustomer, isStripeCustomer, userData) {
    if (!isStripeCustomer) {
        return defaultAddress;
    }
    var shipping = stripeCustomer.shipping || {};
    var address = shipping.address || {};

    return {
        address: address.line1 || '',
        address2: address.line2 || '',
        city: address.city || '',
        country: address.country || '',
        firstName: userData.firstName || '',
        lastName: userData.lastName || '',
        mobileNumber: shipping.phone || '',
        state: address.state || '',
        zip: address.postal_code || ''
    };
});

var isConfirmPasswordTriggered = exports.isConfirmPasswordTriggered = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.confirmPasswordRequiredTriggered;
});

var isUserPartiallyRegistered = exports.isUserPartiallyRegistered = (0, _reselect.createSelector)(getBidderType, function (bidderType) {
    return bidderType === PARTIALLYREGISTEREDBIDDER;
});

var isUserRegistered = (0, _reselect.createSelector)(getBidderType, function (bidderType) {
    return bidderType === REGISTEREDBIDDER;
});

var isUserLoggedIn = exports.isUserLoggedIn = (0, _reselect.createSelector)(getAuthToken, isUserRegistered, function (token, registered) {
    return !!token && registered;
});

var isUserAtLeastPartiallyRegistered = exports.isUserAtLeastPartiallyRegistered = (0, _reselect.createSelector)(isUserPartiallyRegistered, isUserLoggedIn, function (registered, loggedIn) {
    return registered || loggedIn;
});

var getUserData = exports.getUserData = (0, _reselect.createSelector)(isUserAtLeastPartiallyRegistered, userDataSelector, function (userAtLeastPartiallyRegistered, userData) {
    return userAtLeastPartiallyRegistered ? userData : {};
});

var getBidderId = exports.getBidderId = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData.bidderId ? userData.bidderId : -1;
});

var isBidderLoaded = exports.isBidderLoaded = (0, _reselect.createSelector)(getBidderId, function (bidderId) {
    return bidderId > 0;
});

var isProfileComplete = exports.isProfileComplete = (0, _reselect.createSelector)(userDataSelector, function (userData) {
    return userData ? !!userData.profileComplete : false;
});

var getLoadTimeForUserData = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded || 0;
});

var isUserDataLoading = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading || false;
});

var shouldFetchUserData = function shouldFetchUserData(state) {
    var userAtLeastPartiallyRegistered = isUserAtLeastPartiallyRegistered(state);
    if (!userAtLeastPartiallyRegistered) return false;

    var userData = getUserData(state);
    if (userData) {
        var loaded = getLoadTimeForUserData(state);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isUserDataLoading(state);
    return !loading;
};

var getMainhostLogin = exports.getMainhostLogin = (0, _reselect.createSelector)(stateSelector, function (state) {
    return {
        authName: state.authName,
        authNuid: state.authNuid,
        authVerify: state.authVerify
    };
});

/* ACTION CREATORS */
var logOutBidder = exports.logOutBidder = function logOutBidder() {
    return {
        type: LOG_OUT_BIDDER
    };
};

var loadBidderData = function loadBidderData(_ref) {
    var authToken = _ref.authToken,
        deployment = _ref.deployment;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;

                            dispatch({
                                payload: authToken,
                                type: LOAD_BIDDER_DATA_REQUEST
                            });
                            _context.next = 4;
                            return _api.Bidder.fetchBidderData({ authToken: authToken, deployment: deployment });

                        case 4:
                            response = _context.sent;
                            return _context.abrupt('return', dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: LOAD_BIDDER_DATA_SUCCESS
                            }));

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { token: authToken },
                                payload: _context.t0,
                                type: LOAD_BIDDER_DATA_FAIL
                            });
                            dispatch(logOutBidder());

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 8]]);
        }));

        return function (_x6) {
            return _ref2.apply(this, arguments);
        };
    }();
};

var setSearchExclusion = exports.setSearchExclusion = function setSearchExclusion(facetId, optionId, exclude) {
    return function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, authToken, deployment, requestParams, response;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            authToken = getAuthToken(state);
                            deployment = (0, _config.getDeployment)(state);
                            requestParams = { authToken: authToken, deployment: deployment, exclude: exclude, facetId: facetId, optionId: optionId };
                            _context2.prev = 4;

                            dispatch({
                                type: SET_FACET_EXCLUSION_REQUEST
                            });
                            _context2.next = 8;
                            return _api.Bidder.postSetSearchFacetOptionExclusion(requestParams);

                        case 8:
                            response = _context2.sent;

                            dispatch({
                                meta: { actionTime: Date.now() },
                                payload: response.data,
                                type: SET_FACET_EXCLUSION_SUCCESS
                            });
                            _context2.next = 15;
                            break;

                        case 12:
                            _context2.prev = 12;
                            _context2.t0 = _context2['catch'](4);

                            dispatch({
                                error: true,
                                payload: _context2.t0.error_message,
                                type: SET_FACET_EXCLUSION_FAIL
                            });

                        case 15:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined, [[4, 12]]);
        }));

        return function (_x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();
};

var fetchBidderDataIfNeeded = exports.fetchBidderDataIfNeeded = function fetchBidderDataIfNeeded(token, force) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = token || getAuthToken(state);
        var deployment = (0, _config.getDeployment)(state);
        if (force || shouldFetchUserData(state)) {
            return dispatch(loadBidderData({ authToken: authToken, deployment: deployment }));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/user.js
// module id = CFLi
// module chunks = 57